export default {
    ID_ADJUST_URL: "https://wsfy.adj.st/?adj_t=12jc0ahk_12h1x6m0&adj",
    ARTIST_ID_URL: "https://trebel.io/artist?id=",
    JOB_OPENINGS: "https://www.linkedin.com/jobs/search/?f_C=6588013&geoId=92000000",
    PARTNERS_API: "https://partners-api.trebel.io",
    ANALYTICS_API: 'https://analytics.projectcarmen.com/events'
}
